// Nuevo componente llamado Homenews.jsx
import React, { useEffect, useState } from 'react';
import { Box, Heading, StackRow, Stack, Cards } from 'codekit';
import { useSearchHomenewsMutation } from "../../libs/redux/slices/Homenews/homenewsApiSlice";
import PublicPowerBIReport from "./PublicPowerBIReport";


const Homenews = ({ origin }) => {

  const isLoginRequest = origin === "LOGIN-PAGE";
  const isForgotPasswordRequest = origin === "FORGOT-PAGE";

  const [searchHomenews, { isLoading }] = useSearchHomenewsMutation();
  const [searchResults, setSearchResults] = useState([]);

  const search = async () => {
    try {
      const response = await searchHomenews().unwrap();
      setSearchResults(response);
    } catch (error) {
      // Manejo de errores
    }
  };

  useEffect(() => {
    search();
  }, []);

  return (
    <Box>
      {/* Noticias */}
      <Box spacing={6}>
        <Heading variant="heading-2">Noticias</Heading>
        <StackRow>
          <Stack columns={3} gap={5}>
            {searchResults.map((result, index) => (
              <Cards key={index} imageUrl={`${result.notiimgx}`} />
            ))}
          </Stack>
        </StackRow>
      </Box>

      {/* Gestión MapCargo*/}
      <Box mt={8}>
        <Heading variant="heading-2" style={{ color: "#247EAB" }}>
          Gestión MapCargo
        </Heading>
        <Box mt={4}>
          <PublicPowerBIReport />
        </Box>
      </Box>
    </Box>
  );
};

export default Homenews;
